
<div *ngIf="bResetting" class="container-fluid p-2" style="min-height: 770px;">
    <i class="fa fa-spinner fa-spin fa-2x mr-2"></i>Loading...
</div>
<div class="container-fluid p-2" style="min-height: 770px;" *ngIf="!bResetting">
    <div class="d-flex flex-wrap p-2">
        <div class="pr-2">
            <app-waypoint-list #waypointList [pathId]="pathId"
                (mapWaypoints)="onMapWaypointsChanged($event)"
                (pinClicked)="waypointsPlotter.setSelectedPoint($event)">
            </app-waypoint-list>
            <div class="d-flex justify-content-end">
                <button class="btn btn-outline-secondary btn-sm my-1" (click)="showKmlViewer()">
                    <i class="fa fa-globe mr-1"></i>
                    KML
                </button>
            </div>
        </div>
        <div class="d-flex flex-column flex-grow-1">
            <div style="min-width: 400px; min-height: 550px;" class="flex-grow-1">
                <app-waypoints-plotter #waypointsPlotter class="w-100"
                    (pointSelected)="onMapWaypointSelected($event)"
                    [showRefDataFn]="">
                </app-waypoints-plotter>
            </div>
            <app-map-point-summary [mapPoint]="selectedMapWaypoint">

            </app-map-point-summary>
        </div>
    </div>
    <div class="d-flex flex-column align-items-start px-1">
        <app-path-scout-source [bTabSelected]="bTabSelected" [pathId]="pathId" [buildingId]="buildingId"
            [selectedPointId]="selectedMapWaypoint?.pointData?.pointId" (resolvedScoutPath)="resolvedScoutPath = $event?.scoutPath">
        </app-path-scout-source>
        <div *ngIf="roleMgr.canEditUsers" class="d-flex flex-row">
            <button *ngIf="bMissingSegmentCandidate && resolvedScoutPath" [disabled]="bWaypointsModified"
                class="btn btn-sm btn-link px-1 font-italic" (click)="onAssignSegmentsFromScoutPath()">
                Assign Segments using Scout Path
            </button>
            <button *ngIf="bWaypointsModified" class="btn btn-primary mx-2" (click)="onSaveWaypoints()">
                Save</button>
            <button *ngIf="bWaypointsModified" class="btn btn-warning" (click)="onReset()">
                Cancel</button>
        </div>
    </div>
</div>
